module.exports = __webpack_public_path__ + "img/image 02.a90baf0f.png";